module.exports = __webpack_public_path__ + "img/tech-profiles.0e8a7560.svg";